import PageTitle from "../../../components/PageTitle";
import Button from "../../../components/Button";
import { Icon } from "@iconify/react";
import Tabs from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Select from "react-select";
import Password from "../components/Password";
// import RolesandPermission from "../components/RolesandPermission";
// import Apikeys from "../components/Apikeys";
import { Grid } from "@mui/material";
import Modal from "../../../components/Modal";
import DangerModal from "../../../components/DangerModal";
import InputGroup from "../../../components/FormComponent/InputGroup";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { useEffect, useState } from "react";
import styles from "../settings.module.css";
// import image from "../../../assets/images/image.png";
import dot from "../../../assets/images/dot.png";

// --| Dummy Data
import ViewRoles from "../components/ViewRoles";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import { useUserState } from "../../../context/UserContext";
import { useLocation, useNavigate } from "react-router-dom";
import PricingIndex from "../components/PricingIndex";
import AuditTrail from "../../audittrail/index";
import ConfigPage from "../components/ConfigPage";
import Trash from "../../trash/index";
import CustomField from "../components/CustomField";

const ROLES_ENDPOINT = "api/v1/roles";
const EMPLOYEES_ENDPOINT = "api/v1/employees";

const Settings = () => {
  const { profile, subscription } = useUserState();
  const [createapimodal, setCreateApiModal] = useState(false);
  const [createdapimodal, setCreatedApiModal] = useState(false);
  const [rolesData, setRolesData] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [closeAccountModal, setCloseAccountModal] = useState(false);
  const [transferModal, setTransferModal] = useState(false);
  const [confirmationInput, setConfirmationInput] = useState("");
  const [firstDeleteModal, setFirstDeleteModal] = useState(false);
  const [secondDeleteModal, setSecondDeleteModal] = useState(false);
  const [deleteDataModal, setDeleteDataModal] = useState(false);
  const [thirdDeleteModal, setThirdDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [employeesData, setEmployeesData] = useState([]);
  const [selectedNewOwner, setSelectedNewOwner] = useState(null);
  const navigate = useNavigate();
  const subscriptionName = subscription?.pricing_plan?.name;
  const [errors, setErrors] = useState({
    schoolName: "",
    checkbox: ""
  });

  const location = useLocation();
  const currentTab = new URLSearchParams(location.search).get("tab") || "configuration";
  const [value, setValue] = useState(currentTab);

  // Sync tab state with URL changes
  useEffect(() => {
    const tabFromUrl = new URLSearchParams(location.search).get("tab") || "configuration";
    setValue(tabFromUrl);
  }, [location.search]);

  // Handle tab change (both from tabs and manual navigation)
  const handleTabChange = (event, newValue) => {
    navigate(`/settings?tab=${newValue}`, { replace: true });
  };

  /**
   * Toggles the first delete confirmation modal and closes account modal
   */
  const handleFirstDeleteModal = () => {
    setFirstDeleteModal(!firstDeleteModal);
    setCloseAccountModal(false);
  };

  /**
   * Toggles the second delete confirmation modal
   */
  const handleSecondDeleteModal = () => {
    setSecondDeleteModal(!secondDeleteModal);
  };

  /**
   * Toggles the third delete confirmation modal
   */
  const handleThirdDeleteModal = () => {
    setThirdDeleteModal(!thirdDeleteModal);
  };

  const handleCreatedApiModal = () => {
    setCreatedApiModal(!createdapimodal);
  };
  const handleCreateApiModal = () => {
    setCreateApiModal(!createapimodal);
  };

  /**
   * Toggles the delete data modal and closes account modal
   */
  const handleDeleteDataModal = () => {
    setDeleteDataModal(!deleteDataModal);
    setCloseAccountModal(false);
  };

  /**
   * Toggles the transfer ownership modal and closes account modal
   */
  const handleTransferModal = () => {
    setTransferModal(!transferModal);
    setCloseAccountModal(false);
  };

  /**
   * Fetches employee data from API and filters active employees
   */
  const getEmployeeData = () => {
    httprequest
      .get(EMPLOYEES_ENDPOINT)
      .then((res) => {
        const activeEmployees = res?.data?.data?.employees.filter(
          (employee) => employee.is_active === true
        );
        setEmployeesData(activeEmployees || []);
      })
      .catch((err) => {
        toast.error(err?.response?.data || "Failed to fetch employees");
      });
  };

  /**
   * Maps employees data to options for select dropdown
   * @type {Array<{label: string, value: string, name: string}>}
   */
  const userOptions = employeesData?.map((employee) => ({
    label: `${employee.first_name} ${employee.last_name}`,
    value: employee.user_id,
    name: `${employee.first_name} ${employee.last_name}`
  }));

  /**
   * Validates confirmation inputs for critical actions
   * @returns {boolean} True if inputs are valid, false otherwise
   */
  const validateInputs = () => {
    let isValid = true;
    const newErrors = {
      schoolName: "",
      checkbox: ""
    };

    if (confirmationInput !== profile?.school_name) {
      newErrors.schoolName = "School name does not match";
      isValid = false;
    }

    if (!isChecked) {
      newErrors.checkbox = "You must confirm this action";
      isValid = false;
    }

    setErrors(newErrors);

    return isValid;
  };

  /**
   * Handles the first step of account deletion flow
   */
  const handleFirsDeletetStep = () => {
    setFirstDeleteModal(false);
    setSecondDeleteModal(true);
  };

  /**
   * Handles the second step of account deletion flow with validation
   */
  const handleSecondDeleteStep = () => {
    if (!validateInputs()) return;

    setSecondDeleteModal(false);
    setThirdDeleteModal(true);
  };

  /**
   * Handles the transfer of account ownership to another user
   * @async
   */
  const handleOwnershipTransfer = async () => {
    if (!validateInputs()) return;

    if (!selectedNewOwner) {
      toast.error("Please select a new owner");

      return;
    }

    try {
      const payload = {
        school_id: profile?.school_id,
        new_owner_id: selectedNewOwner.value,
        confirm_text: confirmationInput
      };

      const response = await httprequest.post(
        "/api/v1/school/transfer-ownership",
        payload
      );

      toast.success(response.data.message || "Ownership transferred successfully");
      setTransferModal(false);
      setConfirmationInput("");
      setIsChecked(false);
      setSelectedNewOwner(null);
      setErrors({ schoolName: "", checkbox: "" });
      setTimeout(() => {
        navigate("/auth/login");
      }, 1500);
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to transfer ownership"
      );
    }
  };

  /**
   * Handles the deletion of the user account
   * @async
   */

  const handleDeleteAccount = async () => {
    setIsDeleting(true);
    try {
      const response = await httprequest.delete("/api/v1/school/delete-account", {
        data: { confirm_text: confirmationInput }
      });

      toast.success(response.data.message || "Account deleted successfully");
      setThirdDeleteModal(false);

      setConfirmationInput("");
      setIsChecked(false);
      setErrors({ schoolName: "", checkbox: "" });
      setTimeout(() => {
        navigate("/auth/login");
      }, 1500);

      // Optionally redirect after successful deletion
      // window.location.href = '/login';
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        "Failed to delete account. Please try again."
      );
    } finally {
      setIsDeleting(false);
    }
  };

  /**
   * Handles the deletion of all account data
   * @async
   */
  const handleDeleteData = async () => {
    if (!validateInputs()) return;

    httprequest.delete("/api/v1/school/delete-data", {
      data: { confirm_text: confirmationInput }
    }).then((res) => {
      toast.success(res.data.message);
      setDeleteDataModal(false);
      setConfirmationInput("");
      setErrors({ schoolName: "", checkbox: "" });
      setIsChecked(false);
      setTimeout(() => {
        navigate("/auth/login");
      }, 1500);
    }).catch((error) => {
      toast.error(error?.response?.data?.message || "Failed to delete data");
    });
  };

  const getRoles = () => {
    httprequest.get(`${ROLES_ENDPOINT}`).then((res) => {
      const updatedEmployee = res?.data?.data?.filter((newrole) => newrole?.role_type !== "school_admin" && newrole?.role_type !== "guardian" && newrole?.role_type !== "student");
      setRolesData(updatedEmployee);
    }).catch(() => {

    });
  };

  useEffect(() => {
    getRoles();
    getEmployeeData();
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleCloseAccountModal = () => {
    setCloseAccountModal(!closeAccountModal);
  };
  const handleScheduleChange = () => {
    setIsChecked(!isChecked);
  };

  return (
    <div>
      <PageTitle
        title="Settings"
        subtitle="You can make changes to your organisation’s account."
        button={
          <div className="flex gap-10">
            { subscriptionName === "Pro" || subscriptionName === "Enterprise" ?
              <Button
                variant="dangeroutline"
                buttonSize="fluid"
                color="btndanger"
                buttonName="Close Account"
                onClick={handleCloseAccountModal}
              /> : null
            }

            <Button onClick={() => navigate("/profile")} variant="primary" buttonSize="fluid" color="btndefault" buttonName="Profile Settings" />
          </div>
        }
      />
      <TabContext value={value}>
        <div className="tablist-container">
          <Tabs className="overide-tablist" onChange={handleTabChange} aria-label="" value={value}>
            <Tab label="Configuration" value="configuration" />
            <Tab label="Password" value="password" />
            { subscriptionName === "Pro" || subscriptionName === "Enterprise" || subscriptionName === "Partner" ?
              <Tab label="Roles and Permissions" value="roles" />
              : "" }
            <Tab label="Subscription" value="subscription" />
            { subscriptionName === "Pro" || subscriptionName === "Enterprise" || subscriptionName === "Partner" ?
              <Tab label="Audit Trail" value="audit" />
              : "" }
            <Tab label="Trash" value="trash" />
            { subscriptionName === "Pro" || subscriptionName === "Enterprise" || subscriptionName === "Partner" ?
              <Tab label="Custom Field" value="custom-field" />
              : "" }
          </Tabs>
        </div>
        <div className="page-content">
          {value !== "subscription" ?
            <div>
              <div>
                <TabPanel value="password" className="tabpanel-overide">
                  <Password />
                </TabPanel>
                <TabPanel value="roles" className="tabpanel-overide"><ViewRoles /></TabPanel>

                {/* <TabPanel value="3" className="tabpanel-overide"><Apikeys /></TabPanel> */}
              </div>
            </div> :
            <TabPanel value="subscription" className="tabpanel-overide"><PricingIndex /></TabPanel>
          }
          <TabPanel value="audit" className="tabpanel-overide"><AuditTrail /></TabPanel>
          <TabPanel value="configuration" className="tabpanel-overide"><ConfigPage /></TabPanel>
          <TabPanel value="trash" className="tabpanel-overide"><Trash /></TabPanel>
          <TabPanel value="custom-field" className="tabpanel-overide"><CustomField /></TabPanel>
        </div>

      </TabContext>
      {/* Create API Modal */}
      <Modal
        title="Create API Keys"
        subtitle={
          <div>Here you can save and embedded the code for email templates.
          </div>}
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup
                  label="Title"
                  margin="normal"
                  placeHolder="Api title."
                  inputType="text"
                />
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <SelectGroup label="Assign To" children={
                  <select onChange={handleChange} value={rolesData} name="role">
                    <option value="">--- Select ---</option>
                    {rolesData?.map((role) => {
                      return (
                        <option key={role?.role} value={role?.role_id}>{role?.role_name}</option>
                      );
                    })}
                  </select>
                }
                />
              </Grid>
            </Grid>
          </>
        }
        modalFooter={
          <>
            <Button onClick={handleCreatedApiModal} variant="primary" buttonSize="full" color="btndefault" buttonName="Create API keys" />
          </>
        }
        isopen={createapimodal}
        closeModal={handleCreateApiModal}
      />
      {/* Created API Modal */}
      <Modal
        title="API key created"
        modalContent={
          <>
            <Grid container spacing={2} className={`${styles.copyinput}`}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup
                  label="Title"
                  margin="normal"
                  placeHolder="Api created"
                  inputType="text"
                />
                <div className={`${styles.copyicon}`}>
                  <Icon icon="bxs:copy" width="16" height="16" />
                </div>
              </Grid>
            </Grid>
          </>
        }
        modalFooter={
          <>
            <Button onClick={handleCreateApiModal} variant="primary" buttonSize="full" color="btndefault" buttonName="Create API keys" />
          </>
        }
        isopen={createdapimodal}
        closeModal={handleCreatedApiModal}
      />
      {/* Close Account Modal */}
      <DangerModal
        title="Close Account"
        subtitle="Make unchangeable settings to your account."
        modalContent={
          <>
            <Grid container spacing={3} className="input-padding">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div className="flex_space">
                  <div>
                    <p className={`${styles.modalp} bold-700`}>Transfer Ownership</p>
                    <p className={`${styles.modalp}`}>Transfer this account to another user.</p>
                  </div>
                  <Button
                    variant="dangeroutline"
                    buttonSize="fluid"
                    color="btndanger"
                    buttonName="Transfer"
                    onClick={handleTransferModal}
                  />
                </div>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div className="flex_space">
                  <div>
                    <p className={`${styles.modalp} bold-700`}>Delete All Data</p>
                    <p className={`${styles.modalp}`}>Delete all data on this account.</p>
                  </div>
                  <Button
                    variant="dangeroutline"
                    buttonSize="fluid"
                    color="btndanger"
                    buttonName="Delete Data"
                    onClick={handleDeleteDataModal}
                  />
                </div>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div className="flex_space">
                  <div>
                    <p className={`${styles.modalp} bold-700`}>Delete Account</p>
                    <p className={`${styles.modalp}`}>Delete this account.</p>
                  </div>
                  <Button
                    variant="dangeroutline"
                    buttonSize="fluid"
                    color="btndanger"
                    buttonName="Delete Account"
                    onClick={handleFirstDeleteModal}
                  />
                </div>
              </Grid>
            </Grid>
          </>
        }
        isopen={closeAccountModal}
        closeModal={handleCloseAccountModal}
      />
      <DangerModal
        title="Transfer Ownership"
        subtitle="Transfer this account to another user."
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div className="multiple-select">
                  <p>
                    Select a new owner
                    <span className="input-required"> * </span>
                  </p>
                  <Select
                    name="new_owner_id"
                    onChange={(selectedOption) => setSelectedNewOwner(selectedOption)}
                    options={userOptions}
                    className="react-select-container"
                    classNamePrefix="react-select"
                    required
                    closeMenuOnSelect={true}
                  />
                </div>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup
                  label={`Type "${profile?.school_name}" to confirm`}
                  margin="normal"
                  name="school_name"
                  inputValue={confirmationInput}
                  onChange={(e) => {
                    setConfirmationInput(e.target.value);
                    setErrors(prev => ({ ...prev, schoolName: "" }));
                  }} placeHolder="Enter Your School Name"
                  inputType="text"
                />
                {errors.schoolName && (
                  <p className="error-message" style={{ color: "#9E0A05", fontSize: "12px", margin: "0", marginTop: "5px" }}>
                    {errors.schoolName}
                  </p>
                )}
              </Grid>
              <div className={`${styles.check}`}>
                <input
                  type="checkbox"
                  name="custom_form"
                  checked={isChecked}
                  onChange={() => {
                    handleScheduleChange();
                    setErrors(prev => ({ ...prev, checkbox: "" }));
                  }}
                />
                <label className="checkbox-label" htmlFor="custom_form">
            I understand once I transfer ownership, there is no going back.
                </label>
                {errors.checkbox && (
                  <p className="error-message" style={{ color: "#9E0A05", fontSize: "12px", margin: "0", marginTop: "-3px" }}>
                    {errors.checkbox}
                  </p>
                )}
              </div>
            </Grid>
          </>
        }
        modalFooter={
          <Button
            variant="danger"
            buttonName="Transfer Ownership"
            color="btndefault"
            buttonSize="full"
            onClick={handleOwnershipTransfer}
          />
        }
        isopen={transferModal}
        closeModal={handleTransferModal}
      />
      <DangerModal
        title="Delete Data"
        subtitle="Permanently delete all data on this account."
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={12} md={12} sm={12} xs={12} styles={{ marginLeft: "1rem" }}>
                <div className={`${styles.borderdiv} ${styles.no_margin} input-padding`}>
                  <span className={`${styles.name_char}`}>
                    {profile?.school_name?.charAt(0)}
                  </span>
                  <div className={`${styles.accounttext}`}>
                    <p className={`${styles.bold600}`}>{profile?.school_name}</p>
                    <p className={`${styles.span}`}>{profile?.email} <img src={dot} alt="dot" /> Admin</p>
                  </div>
                </div>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup
                  label={`Type "${profile?.school_name}" to confirm`}
                  margin="normal"
                  name="school_name"
                  inputValue={confirmationInput}
                  onChange={(e) => {
                    setConfirmationInput(e.target.value);
                    setErrors(prev => ({ ...prev, schoolName: "" }));
                  }} placeHolder="Enter Your School Name"
                  inputType="text"
                />
                {errors.schoolName && (
                  <p className="error-message" style={{ color: "#9E0A05", fontSize: "12px", margin: "0", marginTop: "5px" }}>
                    {errors.schoolName}
                  </p>
                )}
              </Grid>
              <div className={`${styles.check}`}>
                <input
                  type="checkbox"
                  name="custom_form"
                  checked={isChecked}
                  onChange={() => {
                    handleScheduleChange();
                    setErrors(prev => ({ ...prev, checkbox: "" }));
                  }}
                />
                <label className="checkbox-label" htmlFor="custom_form">
                 I understand once I delete all data, there is no going back.
                </label>
                {errors.checkbox && (
                  <p className="error-message" style={{ color: "#9E0A05", fontSize: "12px", margin: "0", marginTop: "-3px" }}>
                    {errors.checkbox}
                  </p>
                )}
              </div>
            </Grid>
          </>
        }
        modalFooter={
          <Button
            variant="danger"
            buttonName="Delete Data"
            color="btndefault"
            buttonSize="full"
            onClick={handleDeleteData}

          />
        }
        isopen={deleteDataModal}
        closeModal={handleDeleteDataModal}
      />
      <DangerModal
        title="Delete Account"
        subtitle="Permanently delete this account."
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div className={`${styles.borderdiv} ${styles.no_margin}`}>
                  <span className={`${styles.name_char}`}>
                    {profile?.school_name?.charAt(0)}
                  </span>
                  <div className={`${styles.accounttext}`}>
                    <p className={`${styles.bold600}`}>{profile?.school_name}</p>
                    <p className={`${styles.span}`}>{profile?.email} <img src={dot} alt="dot" /> Admin</p>
                  </div>
                </div>
              </Grid>
            </Grid>
          </>
        }
        modalFooter={
          <div style={{ marginTop: "1rem" }}>
            <Button
              variant="danger"
              buttonName="I want to delete this account"
              color="btndefault"
              buttonSize="full"
              onClick={handleFirsDeletetStep}
            />
          </div>
        }
        isopen={firstDeleteModal}
        closeModal={handleFirstDeleteModal}
      />
      <DangerModal
        title="Delete Account"
        subtitle="Permanently delete this account."
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div className={`${styles.borderdiv} ${styles.no_margin}`}>
                  <span className={`${styles.name_char}`}>
                    {profile?.school_name?.charAt(0)}
                  </span>
                  <div className={`${styles.accounttext}`}>
                    <p className={`${styles.bold600}`}>{profile?.school_name}</p>
                    <p className={`${styles.span}`}>{profile?.email} <img src={dot} alt="dot" /> Admin</p>
                  </div>
                </div>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup
                  label={`Type "${profile?.school_name}" to confirm`}
                  margin="normal"
                  name="school_name"
                  inputValue={confirmationInput}
                  onChange={(e) => {
                    setConfirmationInput(e.target.value);
                    setErrors(prev => ({ ...prev, schoolName: "" }));
                  }} placeHolder="Enter Your School Name"
                  inputType="text"
                />
                {errors.schoolName && (
                  <p className="error-message" style={{ color: "#9E0A05", fontSize: "12px", margin: "0", marginTop: "5px" }}>
                    {errors.schoolName}
                  </p>
                )}
              </Grid>
              <div className={`${styles.check}`}>
                <input
                  type="checkbox"
                  name="custom_form"
                  checked={isChecked}
                  onChange={() => {
                    handleScheduleChange();
                    setErrors(prev => ({ ...prev, checkbox: "" }));
                  }}
                />
                <label className="checkbox-label" htmlFor="custom_form">
                I understand once I delete this account, there is no going back.
                </label>
                {errors.checkbox && (
                  <p className="error-message" style={{ color: "#9E0A05", fontSize: "12px", margin: "0", marginTop: "-3px" }}>
                    {errors.checkbox}
                  </p>
                )}
              </div>
            </Grid>
          </>
        }
        modalFooter={
          <Button
            variant="danger"
            buttonName="Delete Account"
            color="btndefault"
            buttonSize="full"
            onClick={handleSecondDeleteStep}
          />
        }
        isopen={secondDeleteModal}
        closeModal={handleSecondDeleteModal}
      />

      <DangerModal
        title="Delete Account"
        subtitle="This action will permanently delete your account. Please confirm."
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div className={`${styles.borderdiv} ${styles.no_margin}`}>
                  <span className={`${styles.name_char}`}>
                    {profile?.school_name?.charAt(0)}
                  </span>
                  <div className={`${styles.accounttext}`}>
                    <p className={`${styles.bold600}`}>{profile?.school_name}</p>
                    <p className={`${styles.span}`}>{profile?.email} <img src={dot} alt="dot" /> Admin</p>
                  </div>
                </div>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div className={`${styles.warning}`}>
                  <Icon icon="ion:warning-outline" color="#F3A218" />
                  <p>
               Unexpected bad things will happen if you don’t read this!
                  </p>
                </div>
                <p style={{ fontSize: "14px", padding: "0 2rem" }}>This will permanently delete this account, saved data and remove all associations will be permanently deleted.</p>
              </Grid>
            </Grid>
          </>
        }
        modalFooter={
          <Button
            variant="danger"
            buttonName={isDeleting ? "Deleting..." : "Delete Account"}
            color="btndefault"
            buttonSize="full"
            onClick={handleDeleteAccount}
          />
        }
        isopen={thirdDeleteModal}
        closeModal={handleThirdDeleteModal}
      />

    </div>
  );
};

export default Settings;
